
import Vue from 'vue'
import Vuex from 'vuex'
import login from './modlues/login'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    login
  },
  getters,
  state: {},
  mutations: {},
  actions: {},
  namespaced: true
});